(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4259],{

/***/ 44324:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vender/[venderUrlId]/contact",
      function () {
        return __webpack_require__(23962);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 84070:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var config_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73221);



const NoindexRemoval = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
            children: config_constants__WEBPACK_IMPORTED_MODULE_2__/* .APP_ENV */ .Wi === "prod" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {}, "noindex")
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (NoindexRemoval);


/***/ }),

/***/ 89670:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var config_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73221);
/* harmony import */ var utils_helpers_vender_welcome_info__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19575);




const MetaTags = (param)=>{
    let { resolvedUrl , vender , pageType  } = param;
    const titleByPageType = {
        about: "【".concat(vender === null || vender === void 0 ? void 0 : vender.shortname, "】公司介紹－信義居家"),
        contact: "【".concat(vender === null || vender === void 0 ? void 0 : vender.shortname, "】聯繫資訊－信義居家")
    };
    const title = titleByPageType[pageType] || "【".concat(vender === null || vender === void 0 ? void 0 : vender.shortname, "】公司介紹、文章、相簿、特色優惠搶先看－信義居家");
    const { brieflyDescribeText: description , typicalImage  } = (0,utils_helpers_vender_welcome_info__WEBPACK_IMPORTED_MODULE_3__/* .getVenderWelcomeInfo */ .u)(vender);
    const pathName = resolvedUrl === null || resolvedUrl === void 0 ? void 0 : resolvedUrl.split("?")[0];
    const path = config_constants__WEBPACK_IMPORTED_MODULE_2__/* .LS_APP_DOMAIN */ ._8 + pathName;
    const breadcrumbData = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
            {
                "@type": "ListItem",
                position: 1,
                name: "首頁",
                item: "https://livinglife.com.tw"
            },
            {
                "@type": "ListItem",
                position: 2,
                name: "廠商列表",
                item: "https://livinglife.com.tw/vender"
            },
            {
                "@type": "ListItem",
                position: 3,
                name: vender === null || vender === void 0 ? void 0 : vender.shortname,
                item: path
            }
        ]
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: path
            }, "canonical"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "title",
                content: title
            }, "title"),
            !!description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }, "description"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }, "og:title"),
            !!description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description
            }, "og:description"),
            !!(typicalImage === null || typicalImage === void 0 ? void 0 : typicalImage.url) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: typicalImage.url
            }, "og:image"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: path
            }, "og:url"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(breadcrumbData)
                }
            }, "breadcrumb-list-json-ld")
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (MetaTags);


/***/ }),

/***/ 23962:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_common_NoindexRemoval__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84070);
/* harmony import */ var components_pages_Vender_VenderContent__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43231);
/* harmony import */ var components_pages_Vender_VenderContent_MetaTags__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89670);
/* harmony import */ var utils_withLivingSinyi__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93756);





const VenderContactPage = (props)=>{
    var _props_fallbackData;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_NoindexRemoval__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_pages_Vender_VenderContent_MetaTags__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                resolvedUrl: props.resolvedUrl,
                vender: (_props_fallbackData = props.fallbackData) === null || _props_fallbackData === void 0 ? void 0 : _props_fallbackData.vender,
                pageType: "contact"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_pages_Vender_VenderContent__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                ...props
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = ((0,utils_withLivingSinyi__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(VenderContactPage));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3829,5897,9072,9477,231,5616,9705,6760,3997,318,5795,9864,8402,8877,7584,9531,3756,6245,6007,7266,8121,3231,9774,2888,179], function() { return __webpack_exec__(44324); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);